import get from 'lodash/get';
import noop from 'lodash/noop';
import classNames from 'classnames';
import UAParser from 'ua-parser-js';
import React, { PureComponent, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import AppAction from '../../actions/App';
import Glyph from '../Glyph';
import Button from '../Button';
import Spinner from '../Spinner';
import Events from '../../utils/Events';
import Context from '../../utils/Context';
import Payload from '../../utils/Payload';
import Visitor from '../../utils/Visitor';
import focus from '../../utils/FocusLine';
import { getCategoryColor } from '../../utils/Colors';

export const EMPTY = 'EMPTY';
export const BLANK = 'BLANK';

export const modal = (ModalClass, props = {}) => new Promise(async (done) => {
  const { callback } = props;
  const parent = document.body.querySelector('#AppModal').appendChild(document.createElement('div'));
  ReactDOM.render(<ModalClass {...Object.assign({}, props, { parent })} context={Context.context} done={done} />, parent, callback || noop);
}).catch(noop);

export class Modal extends PureComponent {
  static propTypes = {
    parent: PropTypes.object.isRequired,
    done: PropTypes.func.isRequired,
    game: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
    ended: PropTypes.bool.isRequired,
    leap: PropTypes.bool,
    overlay: PropTypes.bool,
    closable: PropTypes.bool,
    closeText: PropTypes.string,
    forceClosable: PropTypes.bool,
  };

  static defaultProps = {
    leap: false,
    overlay: false,
    closable: true,
    closeText: 'とじる',
    forceClosable: false,
  };

  constructor(props, context) {
    super(props, context);
    this.ua = new UAParser();
    this.state = { visible: false, focus: false, yabai: false, hide: false, wait: false, levelup: false };
    this.events = new Events();
    this.effectDuration = 240;
  }

  componentWillMount = () => {
    Visitor.event({ category: 'モーダル', action: this.constructor.displayName });
    Context.context.executeAction(AppAction, new Payload({
      type: AppAction.actionTypes.setStatus,
      entity: { status: { game_interface_enabled: false, modal_open: true } },
    }));
    this.events.delay(async () => {
      while (!this.node) {
        await new Promise((resolve) => setTimeout(resolve, 25));
      }
      this.events.bind(window, 'app:modal:close', this.handleClose);
      this.events.bind(this.node, 'app:modal:close', this.handleClose);
      this.setState({ visible: true });
    });
  };

  componentWillUnmount = () => {
    this.events.clear();
    // this.socket.clear();
    this.handleHideFocusLine();
    this.handleHideFocusLineYabai();
    Events.dispatch(window, 'app:modal:closed');
    if (this.state.onUnmount) {
      this.state.onUnmount();
    }
    if (!this.props.overlay) {
      Context.context.executeAction(AppAction, new Payload({
        type: AppAction.actionTypes.setStatus,
        entity: { status: { game_interface_enabled: true } },
      }));
      Events.dispatch(window, 'app:modal:close');
    }
  };

  handleCloseWithResult = (opt) => this.setState({ visible: false }, () => {
    this.props.done(opt); // eslint-disable-line react/prop-types
    if (!this.props.overlay) {
      Context.context.executeAction(AppAction, new Payload({
        type: AppAction.actionTypes.setStatus,
        entity: { status: { modal_open: false } },
      }));
    }
    this.events.delay(() => {
      const canvas = this.node.querySelector('.ModalFocusLine');
      canvas.width = 0;
      canvas.height = 0;
      clearInterval(this.focusInterval);
      ReactDOM.unmountComponentAtNode(this.props.parent);
      setTimeout(() => this.props.parent.parentNode.removeChild(this.props.parent), 0);
    }, this.effectDuration);
  });

  handleClose = () => this.handleCloseWithResult();

  handleCreateOverlay = async (ModalClass, props = {}) => {
    const nextProps = Object.assign({}, this.props, props, { overlay: true });
    this.setState({ stacked: true });
    const result = await modal(ModalClass, nextProps);
    this.setState({ stacked: false });
    return result;
  };

  handleItemClickBefore = (event) => {
    const id = event.currentTarget.getAttribute('data-id');
    this.handleItemClick({ id: id ? +id : null });
  };

  handleLevelUp = () => {
    this.setState({ levelup: true }, () => {
      this.events.delay(() => this.setState({ levelup: false }), 25);
    });
  };

  handleHideModal = () => (
    Promise.all([
      Context.context.executeAction(AppAction, new Payload({
        type: AppAction.actionTypes.setStatus,
        entity: { status: { modal_background: false } },
      })),
      new Promise((resolve) => this.setState({ hide: true }, resolve)),
    ])
  );

  handleShowModal = () => (
    Promise.all([
      Context.context.executeAction(AppAction, new Payload({
        type: AppAction.actionTypes.setStatus,
        entity: { status: { modal_background: true } },
      })),
      new Promise((resolve) => this.setState({ hide: false }, resolve)),
    ])
  );

  handleShowFocusLine = (opt = {}) => this.setState({ focus: true }, () => {
    const canvas = this.node.querySelector('.ModalFocusLine');
    canvas.width = this.node.offsetWidth;
    canvas.height = this.node.offsetHeight;
    this.focusInterval = focus(canvas, opt);
  });

  handleHideFocusLine = () => this.setState({ focus: false }, () => {
    this.events.delay(() => {
      const canvas = this.node.querySelector('.ModalFocusLine');
      canvas.width = 0;
      canvas.height = 0;
      clearInterval(this.focusInterval);
    }, this.effectDuration);
  });

  // 表示はCSSで頑張る
  handleShowFocusLineYabai = () => this.setState({ yabai: true });
  handleHideFocusLineYabai = () => this.setState({ yabai: false });

  handleShowWait = (callback = noop) => this.setState({ wait: true }, callback);
  handleHideWait = (callback = noop) => this.setState({ wait: false }, callback);

  handleAssignNode = (node) => {
    this.node = node;
  };

  renderItems = (items) => (
    <div className='ModalInventory'>
      {items.map(this.renderItem)}
    </div>
  );

  renderItem = (item, index) => {
    if (Array.isArray(item)) {
      const [name, items] = item;
      const color = getCategoryColor({ name, prefix: '#' });
      return (
        <div key={name} className='full-label'>
          <div className='label' style={{ backgroundColor: color }}>{name}</div>
          <div className='items'>
            {items.map(this.renderItem)}
          </div>
        </div>
      );
    }
    if (item === BLANK) {
      if (this.props.ended) {
        return (
          <div key={`blank${index}`} className='blank ended'>
            <div className='add'>x</div>
            <div className='label'>未設定</div>
          </div>
        );
      }
      return (
        <div key={`blank${index}`} className='blank' onClick={this.handleItemClickBefore}>
          <div className='add'>+</div>
          <div className='label'>未設定</div>
        </div>
      );
    }
    if (item === EMPTY) {
      return (
        <div key={index} className='empty' />
      );
    }
    const color = getCategoryColor({ name: get(item, ['categories', '0', 'name']), prefix: '#' });
    return (
      <div
        key={item.id}
        data-id={item.id}
        className={classNames('item', { displayed: item.displayed, new: !item.displayed && item.new, notread: !item.cashedIn })}
        onClick={this.handleItemClickBefore}
        style={{ borderColor: color }}
      >
        <img src={item.thumbnail} role='presentation' />
      </div>
    );
  };

  renderCloseButton = () => (
    (this.props.forceClosable || !this.props.overlay) ? (
      <Button onClick={this.handleClose}>{this.props.closeText}</Button>
    ) : (
      <Button onClick={this.handleClose}>
        <Glyph name='chevron-left' />
        <span>もどる</span>
      </Button>
    )
  );

  render = () => (
    <div ref={this.handleAssignNode} className={classNames('Modal', { visible: this.state.visible, overlay: this.props.overlay, leap: this.props.leap, hide: this.state.hide, stacked: this.state.stacked })}>
      <canvas className={classNames('ModalFocusLine', { visible: this.state.focus })} width='0' height='0' />
      <div className={classNames('ModalFocusLineYabai', { visible: this.state.yabai })} />
      <div className={classNames('ModalContentWrap', { closable: this.props.closable })}>
        <div className='ModalContent'>
          <div className={classNames('ModalLvEffect', { hidden: !this.state.levelup })}>
            <span>LVUP!!</span>
          </div>
          {this.renderContent()}
          {this.state.wait && <div className='ModalLoad'><Spinner /></div>}
        </div>
      </div>
      {this.props.closable && (
        <div className={classNames('ModalClose', { overlay: (!this.props.forceClosable && this.props.overlay) })}>
          {this.renderCloseButton()}
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/Modal/Modal.jsx